import { Component, ViewEncapsulation, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-error-dialog',
  templateUrl: './alert-error-dialog.component.html',
  styleUrls: ['./alert-error-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AlertErrorDialogComponent {

  panelOpenState: boolean = false;
  data: any;

  constructor(
    public matDialogRef: MatDialogRef<AlertErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any
  ) {
    this.data = _data;
  }

}
